import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";

import Loader from "../components/Loader";
import MainLayout from "../layouts/MainLayout";
import AuthLayout from "../layouts/AuthLayout";

import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import CodeLineage from "../pages/CodeLineage";
import KBAccelerator from "../pages/KBAccelerator";
import AdvancedCodeLineage from "../pages/AdvancedCodeLineage";

// Lazy-loaded pages
const Home = lazy(() => import("../pages/Home"));
const Login = lazy(() => import("../pages/Login"));

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loader />}>
        <Routes>

          {/* ✅ Public Home */}
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          {/* <Route element={<AuthLayout />}>
            <Route path="/" element={<Home />} />
          </Route> */}

          {/* ✅ Public Auth Pages */}
          <Route element={<PublicRoute />}>
            <Route element={<AuthLayout />}>
              <Route path="/login" element={<Login />} />
            </Route>
          </Route>

          {/* ✅ Private Pages */}
          <Route element={<PrivateRoute />}>
            <Route element={<MainLayout />}>
              <Route path="/insight-hub" element={<KBAccelerator />} />
            </Route>
            <Route element={<MainLayout />}>
              <Route path="/lineage-studio" element={<CodeLineage />} />
            </Route>
            <Route element={<MainLayout />}>
              <Route path="/advanced-lineage-studio" element={<AdvancedCodeLineage />} />
            </Route>
          </Route>

        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default AppRoutes;
